import { render } from "./SignUpConfirm.vue?vue&type=template&id=5a9eba7e&scoped=true"
import script from "./SignUpConfirm.vue?vue&type=script&lang=js"
export * from "./SignUpConfirm.vue?vue&type=script&lang=js"

import "./SignUpConfirm.vue?vue&type=style&index=0&id=5a9eba7e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2671924258/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9eba7e"]])

export default __exports__